import { render, staticRenderFns } from "./BusinessInformationCompanyInfo.vue?vue&type=template&id=e4045a10"
import script from "./BusinessInformationCompanyInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInformationCompanyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports